import React from 'react';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sarah Johnson',
    position: 'Marketing Director',
    company: 'TechSolutions Inc.',
    image: 'https://randomuser.me/api/portraits/women/4.jpg',
    quote: 'Working with Otterreach transformed our lead generation strategy. Within 3 months, we saw a 187% increase in qualified leads and a 43% increase in conversions.'
  }, {
    name: 'Michael Chen',
    position: 'CEO',
    company: 'Innovate Partners',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
    quote: "Their team's attention to detail and data-driven approach helped us identify opportunities we were missing. Our cost per acquisition dropped by 38% while lead quality improved significantly."
  }, {
    name: 'Amanda Rodriguez',
    position: 'Sales Director',
    company: 'Global Finance Group',
    image: 'https://randomuser.me/api/portraits/women/19.jpg',
    quote: "Otterreach doesn't just deliver leads, they deliver results. Their strategic approach and continuous optimization have made them an invaluable partner in our growth."
  }, {
    name: 'David Wilson',
    position: 'Founder',
    company: 'HealthPlus',
    image: 'https://randomuser.me/api/portraits/men/46.jpg',
    quote: 'In a competitive industry like healthcare, quality leads are everything. Otterreach understood our unique challenges and created a customized strategy that exceeded our expectations.'
  }];
  return <section id="testimonials" className="py-28 bg-white relative overflow-hidden" data-id="element-298">
      {/* Decorative elements */}
      <div className="absolute top-40 left-0 w-72 h-72 bg-amber-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-299"></div>
      <div className="absolute bottom-40 right-0 w-96 h-96 bg-red-100 rounded-full opacity-20 blur-3xl -z-10" data-id="element-300"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-301">
        <div className="text-center mb-20" data-id="element-302">
          <div className="inline-block px-3 py-1 text-xs font-semibold text-amber-600 bg-amber-100 rounded-full mb-4" data-id="element-303">
            Testimonials
          </div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-304">
            What Our Clients Say
          </h2>
          <p className="mt-4 max-w-2xl text-xl text-gray-500 mx-auto" data-id="element-305">
            Don't just take our word for it. Here's what our clients have to say
            about working with Otterreach.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-306">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group hover:border-amber-100 hover:translate-y-[-5px] relative" data-id="element-307">
              <div className="absolute top-6 right-6 text-amber-100" data-id="element-308">
                <Quote className="h-20 w-20 transform rotate-180" data-id="element-309" />
              </div>
              <div className="relative z-10" data-id="element-310">
                <div className="flex items-center space-x-1 mb-6" data-id="element-311">
                  {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current text-amber-400" data-id="element-312" />)}
                </div>
                <p className="text-gray-700 text-lg mb-8 leading-relaxed" data-id="element-313">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center" data-id="element-314">
                  <img src={testimonial.image} alt={testimonial.name} className="h-14 w-14 rounded-full mr-4 border-2 border-white shadow-md object-cover" data-id="element-315" />
                  <div data-id="element-316">
                    <div className="font-bold text-gray-900 text-lg" data-id="element-317">
                      {testimonial.name}
                    </div>
                    <div className="text-gray-600" data-id="element-318">
                      {testimonial.position}, {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
        <div className="mt-24 bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl shadow-xl p-12 text-center relative overflow-hidden" data-id="element-319">
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden" data-id="element-320">
            <div className="absolute top-10 left-10 w-40 h-40 bg-amber-400/10 rounded-full blur-3xl" data-id="element-321"></div>
            <div className="absolute bottom-10 right-10 w-60 h-60 bg-red-400/10 rounded-full blur-3xl" data-id="element-322"></div>
          </div>
          <div className="relative z-10" data-id="element-323">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-324">
              Ready to Join Our Success Stories?
            </h3>
            <p className="text-gray-300 text-lg max-w-2xl mx-auto mb-10" data-id="element-325">
              Schedule a free consultation today and see how we can help your
              business generate more qualified leads.
            </p>
            <a href="#contact" className="inline-flex items-center px-8 py-4 border border-transparent text-lg font-medium rounded-lg shadow-lg text-gray-900 bg-gradient-to-r from-amber-400 to-red-400 hover:from-amber-500 hover:to-red-500 transition-all duration-300 hover:shadow-amber-500/20" data-id="element-326">
              Schedule Free Consultation
            </a>
          </div>
        </div>
      </div>
    </section>;
}